module.exports = __webpack_public_path__ + "static/img/about.742a27bd.png";